module.exports = __webpack_public_path__ + "media/components/src/assets/images/image_text/11-1c3a70e75b00d88ca1262544b064fbd2.jpg";